'use strict';

// кастомные события отправляются скриптом подключаемый на ВЛ - https://github.com/sravni/widgets-frontend/blob/master/public/loader.js
const checkViewportMessage = (value, event) => !!value &&
    typeof value === 'object' &&
    'event' in value &&
    value.event === event &&
    'innerHeight' in value &&
    typeof value.innerHeight === 'number' &&
    'iframeOffsetTop' in value &&
    typeof value.iframeOffsetTop === 'number' &&
    'visualViewport' in value &&
    typeof value.visualViewport === 'object';
const isIVisualViewportResizeMessage = (value) => checkViewportMessage(value, 'IFRAME_RESIZE_VISUAL_VIEWPORT');
const isIVisualViewportScrollMessage = (value) => checkViewportMessage(value, 'IFRAME_SCROLL_VISUAL_VIEWPORT');

exports.isIVisualViewportResizeMessage = isIVisualViewportResizeMessage;
exports.isIVisualViewportScrollMessage = isIVisualViewportScrollMessage;
//# sourceMappingURL=isTVisualViewportMessage.js.map
